<template>
  <div
    class="table-responsive mt-5"
    style="min-height: 450px; padding: 10px 0px"
  >
    <Loader v-if="loading" />
    <div v-else>
      <div class="d-flex flex-column align-items-start mb-2 p-4">
        <div class="search-div btn-rounded teal">
          <p
            @click="showSearchModal"
            style="cursor: pointer;line-height: 30px;"
          >
            送信一覧検索
          </p>
          <ContactSearch v-if="searchModal" />
        </div>
      </div>
      <table class="table">
        <thead>
          <tr>
            <th style="width: 5%;"></th>
            <th style="width: 10%">送信日</th>
            <!-- <th style="width: 10%">登録/更新日</th> -->
            <th style="width: 15%;">氏名</th>
            <th style="width: 30%;">スカウト求人</th>
            <th class="text-center" style="width: 15%;">
              <b-dropdown
                id="response-dropdown"
                text="回答結果"
                variant="primary"
                class="m-2 th-dropdown"
                @hidden="search"
                @shown="overflow"
              >
                <div>
                  <div
                    class="form-check form-check"
                    v-for="(response, index) in userResponses"
                    v-bind:key="index"
                  >
                    <input
                      type="checkbox"
                      :id="'response-' + index"
                      :value="response"
                      class="form-check-input"
                      v-model="userResponseModel"
                    />
                    <label class="form-check-label">{{ response }}</label>
                  </div>
                </div>
              </b-dropdown>
            </th>
            <th style="width: 15%;">差出人名</th>
            <th style="width: 10%;"></th>
          </tr>
        </thead>
        <tbody>
          <SentContactsRow
            v-for="(item, index) in sentContacts"
            :index="index"
            :key="item._id"
            :sentContact="item"
            :rowNumber="rowNumber(index)"
            @toggleInterview="handleInterviewToggle"
          />
        </tbody>
        <tr v-if="showEmptyContactMessage">
          <td colspan="100%" class="text-center">
            登録者が見つかりませんでした
          </td>
        </tr>
      </table>

      <div class="pagination-area" v-if="totalPages > 0">
        <GlobalPaginate
          :total-page="totalPages"
          :callback="changePage"
          :currentPage="page"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations, mapState } from 'vuex';
import StatusBox from './StatusBox.vue';
import SentContactsRow from './SentContactsRow.vue';
import GlobalPaginate from '../../../utils/GlobalPaginate.vue';
import Loader from '../../../utils/Loader.vue';
import ContactSearch from './ContactSearch.vue';
export default {
  data() {
    return {
      tableData: [], // Initialize with an empty array,
      openProfile: null,
      // showSearchModal: false,
      // pagination: {},
      // page:1,
      // loading: false,
      params: {},
      overflowState: 0,
      showEmptyMessage: false,
      userResponses: [
        '選考応募',
        'カジュアル面談',
        '面接参加',
        '質問',
        '応募見合わせ',
        '(通知のみ)',
      ],
      // userResponseModel: [],
    };
  },
  components: {
    StatusBox,
    SentContactsRow,
    GlobalPaginate,
    Loader,
    ContactSearch,
  },
  computed: {
    ...mapState({
      searchParams: (state) => state.individual_contact.sentSearchParams,
      page: (state) => state.individual_contact.sentPage,
      pagination: (state) => state.individual_contact.sentContactsPagination,
    }),
    ...mapGetters({
      sentContacts: 'getSentContacts',
      getClientStatus: 'getClientStatus',
      getSentStatusModel: 'getSentStatusModel',
      pagination: 'getSentContactsPagination',
      searchParams: 'getSentSearchParams',
      getUserResponseModel: 'getUserResponseModel',
      loading: 'getLoading',
      searchModal: 'getSearchModal',
    }),
    statusModel: {
      get() {
        return this.getSentStatusModel;
      },
      set(value) {
        this.setSentStatusModel(value);
      },
    },
    userResponseModel: {
      get() {
        return this.getUserResponseModel;
      },
      set(value) {
        this.setUserResponseModel(value);
      },
    },
    totalPages() {
      const { pagination } = this;
      // console.log(pagination.total
      //   ? Math.ceil(pagination.total / pagination.perPage)
      //   : 0);
      return pagination.total
        ? Math.ceil(pagination.total / pagination.perPage)
        : 0;
    },
    showEmptyContactMessage() {
      return this.sentContacts.length === 0;
    },
  },
  methods: {
    ...mapActions({ loadSentContacts: 'loadSentContacts' }),
    ...mapMutations([
      'setSentContacts',
      'setSentStatusModel',
      'setSentContactsPagination',
      'setLoading',
      'setSentPage',
      'setUserResponseModel',
      'toggleSearchModal',
    ]),
    showSearchModal() {
      this.toggleSearchModal(true);
    },
    overflow() {
      this.overflowState = 1;
    },
    showProfile(item) {
      this.openProfile = item.receiver._id;
    },
    // setPage(page){
    //     this.page = page
    // },
    rowNumber(index) {
      // console.log(index);
      return (
        index +
        1 +
        (parseInt(this.pagination.current, 10) - 1) * this.pagination.perPage
      );
    },
    changePage(page) {
      this.setSentPage(page);
    },
    filter() {
      const params = {};
      Object.assign(params, this.params);
      params.status = this.statusModel;
    },
    buildParams(page = null) {
      this.searchParams.status = this.statusModel;
      this.searchParams.user_response = this.userResponseModel;
      const params = {
        ...this.searchParams,
        page: page || 1,
      };
      return params;
    },
    search() {
      this.loadSentMessages(this.buildParams(1));
    },
    async loadSentMessages(params = {}) {
      try {
        this.setLoading(true);
        let contacts = await this.loadSentContacts(params);
        let sentContacts = contacts.data.data;
        // this.pagination = contacts.data.meta.pagination;
        this.setSentContacts(sentContacts);
        this.setSentContactsPagination(contacts.data.meta.pagination);
        this.setLoading(false);
      } catch (err) {
        this.setLoading(false);
        console.log(err);
      }
    },
    handleInterviewToggle(data) {
      // Handle interview toggle event
      console.log('Interview toggled:', data);
      // You can add API call here to update the interview status
      // Example: this.updateInterviewStatus(data.contactId, data.interview);
    },
  },
  mounted() {
    this.changeBodyToWhite();
  },
  async created() {
    await this.loadSentMessages(this.buildParams(1));
  },
  watch: {
    page: function(currentPage) {
      this.loadSentMessages(this.buildParams(currentPage));
    },
    searchParams: {
      handler(newParams) {
        if (newParams && Object.keys(newParams).length > 0) {
          // this.loading = true;  // Set loading to true before making the request
          this.loadSentMessages(this.buildParams(1));
          this.setSentPage(1);
        }
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
>>> .th-dropdown .btn {
  font-size: 14px !important;
}

table {
  table-layout: fixed;
  width: 100%;
}
.search-div {
  border: 1px solid #006c6b;
  background-color: #006c6b;
  padding: 8px;
  color: #fff;
  text-align: center;
  font-size: 16px;
  width: 170px !important;
}
table th {
  text-align: center !important;
  /* font-size: 12px !important; */
}
table td {
  text-align: center !important;
  /* font-size: 12px !important; */
}
</style>
